import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';

const initialState = {
    isFetching: false,
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    data: {
        recommendation: []
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.GET_RECOMMENDATION_ACTION:
            return { ...state, isFetching: true };
        case Types.GET_RECOMMENDATION_SUCCESS:
            return { ...state, isFetching: false,
                pageSize: action.recommend.pageSize,
                pageIndex: action.recommend.pageIndex,
                totalCount: action.recommend.totalCount,
                totalPage: Math.ceil(parseInt(action.recommend.totalCount) / parseInt(action.recommend.pageSize)),
                data: {
                recommendation: action.recommend.result
            }};   
        case Types.GET_RECOMMENDATION_FAIL:
            return { ...state, isFetching: false };

        default:
            return state;
    }
}